import { render, staticRenderFns } from "./activitiesAndTravels.vue?vue&type=template&id=9d0bf8ac&scoped=true"
import script from "./activitiesAndTravels.vue?vue&type=script&lang=js"
export * from "./activitiesAndTravels.vue?vue&type=script&lang=js"
import style0 from "./activitiesAndTravels.vue?vue&type=style&index=0&id=9d0bf8ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d0bf8ac",
  null
  
)

export default component.exports